import React from "react";
import { Box, Card, CardContent, Typography, Divider, Grid, List, ListItem, ListItemText } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useParams, useNavigate } from 'react-router-dom'
import moment from 'moment'
import { useSelector } from 'react-redux'
import FormatNumber from "../../../CommonComponents/FormatNumber";

const ApplicantView = ({ data }) => {
  console.log(data)
const navigate = useNavigate()
const { ServicesData, OtherServiceData } = useSelector((state) => state.CommonData);
  const applicant = data?.data || {};
  const details = applicant?.PersonalData?.Details || {};
  const emergencyContacts = applicant?.PersonalData?.Emergency_contact || [];
  const services = applicant?.ServicesValue || {};
  const roomData = applicant?.RoomsData?.selectedRoom || {};
  const serviceValue = applicant?.ServicesValue
  console.log(emergencyContacts)

  return (
    <Box sx={{ maxWidth: 800, margin: "auto", p: 3 }}>
    {/* Applicant Information */}

    <Box sx={{mb : 4}}>
        <ArrowBackIcon onClick={() => navigate('/Admin/users')} sx={{fontSize : '2rem', fontWeight : 700, ':hover' : {cursor : 'pointer'}}}/>
    </Box>
    <Card sx={{ mb: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h5" fontWeight="bold">Applicant Information</Typography>
        <Divider sx={{ my: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={6}><Typography><b>Name:</b> {details?.name || '-'}</Typography></Grid>
          <Grid item xs={6}><Typography><b>Date of Birth:</b> {details?.dob ? moment(details?.dob).format("MMM DD YYYY") : '-'}</Typography></Grid>
          <Grid item xs={6}><Typography><b>Nationality:</b> {details?.nationality
  ? details.nationality.charAt(0).toUpperCase() + details.nationality.slice(1).toLowerCase()
  : '-'}</Typography></Grid>
  <Grid item xs={6}><Typography><b>Email:</b> {applicant?.email || '-'}</Typography></Grid>
          <Grid item xs={6}><Typography><b>Gender:</b> {details?.gender || '- '}</Typography></Grid>
          <Grid item xs={6}><Typography><b>Passport Number:</b> {details?.passport_no || '-'}</Typography></Grid>
          <Grid item xs={6}><Typography><b>School:</b> {details?.school || '-'}</Typography></Grid>
          <Grid item xs={6}><Typography><b>Contact Number:</b> {details?.contact_no ? <FormatNumber number={`+${details?.contact_no}`} /> : '-'}</Typography></Grid>
          <Grid item xs={6}><Typography><b>WhatsApp :</b> {details?.whatsapp || '-'}</Typography></Grid>
          <Grid item xs={6}><Typography><b>LINE :</b> {details?.line || '-'}</Typography></Grid>
          <Grid item xs={6}><Typography><b>WeChat :</b> {details?.wechat || '-'}</Typography></Grid>
          <Grid item xs={6}><Typography><b>Kakaotalk :</b> {details?.kakaotalk || '-'}</Typography></Grid>
          <Grid item xs={6}><Typography><b>Zalo :</b> {details?.zalo || '-'}</Typography></Grid>
          
          <Grid item xs={6}><Typography><b>Notes:</b> {details?.note || "-"}</Typography></Grid>
        </Grid>
      </CardContent>
    </Card>

    {/* Uploaded Documents */}
    <Card sx={{ mb: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h5" fontWeight="bold">Uploaded Documents</Typography>
        <Divider sx={{ my: 2 }} />
        <Typography><b>IPA File:</b></Typography>
        {details?.ipaFile?.filename?.length > 0 ? (
  details.ipaFile.filename.toLowerCase().endsWith('.pdf') ? (
    <iframe
      src={`${process.env.REACT_APP_FILE_PATH}${details.ipaFile.filename}`}
      width="100%"
      height="500px"
      title="IPA PDF Preview"
      style={{ border: 'none' }}
    />
  ) : (
    <Box
      component="img"
      src={`${process.env.REACT_APP_FILE_PATH}${details.ipaFile.filename}`}
      alt="IPA File"
      sx={{ maxWidth: '100%', height: 'auto' }}
    />
  )
) : (
  '-'
)}

<Typography sx={{mt : 4}}><b>Passport:</b></Typography>
        {details?.passport?.filename?.length > 0 ? (
  details.passport.filename.toLowerCase().endsWith('.pdf') ? (
    <iframe
      src={`${process.env.REACT_APP_FILE_PATH}${details.passport.filename}`}
      width="100%"
      height="500px"
      title="IPA PDF Preview"
      style={{ border: 'none' }}
    />
  ) : (
    <Box
      component="img"
      src={`${process.env.REACT_APP_FILE_PATH}${details.passport.filename}`}
      alt="IPA File"
      sx={{ maxWidth: '100%', height: 'auto' }}
    />
  )
) : (
  '-'
)}
      </CardContent>
    </Card>

    {/* Emergency Contact */}
    <Card sx={{ mb: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h5" fontWeight="bold">Emergency Contact</Typography>
        <Divider sx={{ my: 2 }} />
        <List>
        {emergencyContacts.length > 0 ?
        emergencyContacts?.map((contact, index) => (
          <ListItem key={index} divider>
            <ListItemText
              primary={<b>Name : {contact?.Emergency_name}</b>}
              secondary={
                <>
                  <Typography><b>Email:</b> {contact?.Emergency_email}</Typography>
                  <Typography><b>Contact Number:</b> <FormatNumber number={`+${contact?.Emergency_contact_no}`} /></Typography>
                  <Typography><b>WhatsApp :</b> {contact?.Emergency_whatsapp}</Typography>
                  <Typography><b>WeChat :</b> {contact?.Emergency_wechat}</Typography>
                  <Typography><b>LINE :</b> {contact?.Emergency_line}</Typography>
                  <Typography><b>Zalo:</b> {contact?.Emergency_zalo}</Typography>
                </>
              }
            />
          </ListItem>
        ))
        :
        '-'
        }
          
        </List>
      </CardContent>
    </Card>

    {/* Flight & Arrival Information */}
    <Card sx={{ mb: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h5" fontWeight="bold">Flight & Arrival Information</Typography>
        <Divider sx={{ my: 2 }} />
        <Typography><b>Flight Number:</b> {services?.fligt_no || '-'}</Typography>
        <Typography><b>Arrival Date:</b> {services?.arrival_date ? moment(services?.arrival_date).format("MMM DD YYYY") : '-'}</Typography>
        <Typography><b>Arrival Time:</b> {services?.arrival_date ? moment(services?.arrival_date).format("hh:mm A") : '-'}</Typography>
        <Grid xs={12} sm={5.8} my={2}>
        <Typography variant="h7_2">
                  Landing Services
                </Typography>
                <br />
                {ServicesData.map((service, index) => (
                  <>
                  <Box sx={{display : 'flex', gap : '5px'}}>
                  <Typography sx={{color : 'rgba(26, 36, 97, 1)'}}>{service.title} -</Typography>
                  <Typography sx={{color : serviceValue?.landingServices?.includes(service._id) ? 'rgba(82, 173, 51, 1)' : 'gray', fontWeight : 700}}>{serviceValue?.landingServices?.includes(service._id) ? " Included" : " Not Included"}</Typography>
                  </Box>
                  </>
                ))}
        </Grid>

        <Grid xs={12} sm={5.8} my={2}>
        <Typography variant="h7_2">
                  Other Chargeable Services
                </Typography>
                <br />
                {OtherServiceData.map((service, index) => (
                  <>
                  <Box sx={{display : 'flex', gap : '5px'}}>
                  <Typography sx={{color : 'rgba(26, 36, 97, 1)'}}>{service?.title} -</Typography>
                  <Typography sx={{color : serviceValue?.otherServices?.includes(service._id) ? 'rgba(82, 173, 51, 1)' : 'gray', fontWeight : 700}}>{serviceValue?.otherServices?.includes(service._id) ? "Included" : "Not Included"}</Typography>
                  </Box>
                  </>
                ))}
</Grid>
      </CardContent>
    </Card>

    {/* Room Allocation Details */}
    <Card sx={{ mb: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h5" fontWeight="bold">Room Allocation Details</Typography>
        <Divider sx={{ my: 2 }} />
        <Typography><b>Hostel Name:</b> {roomData?.HostelName || '-'}</Typography>
        <Typography><b>Room Type:</b> {roomData?.room_type_name?.en || roomData?.room_type_name || '-'}</Typography>
        <Typography><b>Contract Length:</b> {applicant?.RoomsData?.contractLength ? (applicant?.RoomsData?.contractLength == 1 ? '6' : '12') : '-'} Month(s)</Typography>
      </CardContent>
    </Card>
  </Box>
  );
};

export default ApplicantView;
